export default {
  'chat.avatar': 'avatar',
  'chat.placeholder': '...',
  'tokenTag.overload': 'Overload',
  'tokenTag.remained': 'Remained',
  'tokenTag.used': 'Used',
} as const;
